import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.API_TESTING)

const TESTING_LIFECYCLE = ['Analyse', 'Design', 'Execute', 'Validate', 'Automate', 'Monitor']
const WHAT_WE_TEST = [
  {title: 'API Functionality',desc:'Validate endpoints, requests, responses, parameters, authentication, and business rules.'},
  {title: 'Data & Response Validation',desc:'Verify response structures, data accuracy, status codes, error handling, and data consistency.'},
  {title: 'Integration Testing', desc:'Test communication between APIs, applications, databases, microservices, and third-party systems.'},
  { title: 'Authentication & Access Controls',desc:'Validate authentication mechanisms, authorization, roles, permissions, and access scenarios.'},
  { title: 'API Performance',desc:'Measure response times, throughput, concurrency, and behaviour under increasing request volumes.'},
  { title: 'Negative & Edge-Case Testing',desc:'Test invalid inputs, unexpected requests, boundary conditions, failures, and exception handling.'},
]

const STACK_BADGES = [ 
  // Middle — 4 badges, 90° apart
  { label: 'Endpoints', tier: 'middle', angle: 0   },
  { label: 'Data', tier: 'middle', angle: 70  },
  { label: 'Integrations', tier: 'middle', angle: 140 },
  { label: 'Security', tier: 'middle', angle: 210 },
  { label: 'Reliability', tier: 'middle', angle: 280 },
]

// const TIER_SIZE = { inner: '44%', middle: '72%', outer: '100%' }
const TIER_SIZE = {
  inner: '48%',
  middle: '76%',
  outer: '100%',
}
// Inner orbits slowest, outer fastest — matches how real orbital motion looks.
const TIER_DURATION = { inner: 44, middle: 26, outer: 16 } // seconds


export default function APITesting() {
  

  return (
    <>
    {/* <MetaInfo
    title="API & Integration Testing | CruxBytes"
    description="Validate REST APIs, integrations, data flows, security, performance, and reliability with comprehensive API testing services from CruxBytes."
    keywords="API testing, API integration testing, REST API testing, API security testing, API performance testing, QA services, CruxBytes"    
  /> */}
   <MetaInfo
        title={`${label} ${SITE.metaTagPostText}`} 
        description={metaDesc}
        keywords=""
        />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">             
              <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* API Testing */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Validate API performance, reliability, and security for seamless integrations. */}
             {pageDesc}
             </p>
            
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
              {/* Section 1 */}
         
                 <section className="section-py bg-linear-gradient-light"  >
                   <div className="container">
                     <div className="section-header pt-4" data-aos="fade-up">                       
                       <p className="text-center">
                         APIs are the foundation connecting modern applications, services, databases, mobile apps, and third-party platforms. A problem at the API layer can impact multiple systems at once.
                       </p>
                       <p className="text-center">
                         CruxBytes tests APIs for functionality, reliability, data accuracy, performance, security, and integration behaviour—helping ensure that the systems behind your applications work as expected. We help your development team to validate the technology underlying your application.
                       </p>
                      
                     </div>
                   </div>
                 {/* </section>

<section className="section-py bg-peach "> */}
    <div className="container ">
      
       <div className="on-demand-split no-gap">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" >
           <div className="">
           
  <ul className="check-list ps-0">
     <h5>What We Test</h5>
    {WHAT_WE_TEST.map((card, i) => (
      <li
        key={card.title}
        data-aos="fade-up"
        data-aos-delay={(i % 3) * 80}
      >
        {/* <i className="fa-solid fa-circle-check check-list-icon" aria-hidden="true" /> */}
        {/* <i className="fa-regular fa-thumbs-up check-list-icon" aria-hidden="true" /> */}
        <i className="fa-regular fa-star check-list-icon" aria-hidden="true" />
        <div>
          <h6 className="mb-0">{card.title}</h6>
          <p className="wcs-desc">{card.desc}</p>
        </div>
      </li>
    ))}
  </ul>
</div>
              
        </div>
        {/* ── RIGHT:  ── */}
        <div   data-aos="fade-left">  
         <div className="pf-orbit-wrap m-0" data-aos="fade-left">
         
        <div className="stack-orbit" data-aos="fade-left">
          {/* <span className="stack-ring testing-ring stack-ring--1" aria-hidden="true" /> */}
          <span className="stack-ring testing-ring stack-ring--2" aria-hidden="true" />
          <span className="stack-ring  testing-ring stack-ring--3" aria-hidden="true" />
          <span className="stack-testing-center-pill">Can everything <br /> communicate reliably?</span>
          {STACK_BADGES.map((badge) => (
            <span
              key={badge.label}
              className="stack-orbit-track"
              style={{
                width: TIER_SIZE[badge.tier],
                height: TIER_SIZE[badge.tier],
                '--start-angle': `${badge.angle}deg`,
                animationDuration: `${TIER_DURATION[badge.tier]}s`,
              }}
            >
              <span className="stack-badge" style={{ animationDuration: `${TIER_DURATION[badge.tier]}s` }}>
                {/* <badge.Icon />  */}
                {badge.label}
              </span>
            </span>
          ))}
        </div>
        </div>
        </div>
      </div>
    </div>
</section>
      {/* Section 3 */}
         <section className="section-py ">
                <div className="container ">
        <div className="on-demand-split">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
        
          <div className="cp-timeline-header">
            <h2 >Test the Layer Behind Every Digital Experience</h2>
            <p >
            Our API testing approach combines manual and automated testing techniques to validate APIs throughout the development and release lifecycle.
            </p> 
            <p>
              Thorough API testing helps prevent integration failures, improve data reliability, strengthen application quality and provide a stable foundation for connected digital ecosystems.
            </p>           
          </div>     
        </div>
                {/* ── RIGHT:  ── */}
        <div   data-aos="fade-left">  
          <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
            <h6>Reliable APIs. Connected Systems. Better Applications.</h6>
            <ol className="step-flow  mt-4" role="list" aria-label="Testing lifecycle">
              {TESTING_LIFECYCLE.map((step) => (
                <li key={step} className="step-flow-item">
                  <span className="step-flow-label" style={{fontSize:'var(--fs-xs)'}}>{step}</span>
                </li>
              ))}
            </ol>
            
            
          </div>
        </div>
        </div>   
      </div>                
         </section>
         <TransformBanner />
         </main>
         </>
  )
}